import Api from './api'

const privateAccountPath = '/private/account'
const publicAccountPath = '/public/account'
const publicResetPasswordRequestPath = `${publicAccountPath}/resetpasswordrequest`
const resetPasswordPathPublic = `${publicAccountPath}/resetpassword`
const policyDocsPathPart = 'policy_docs'

export default {

  /**
   * an admin function to get all users, with an optional search term
   * @param pageNumber - page number, zero based
   * @param pageSize -
   * @param sortDir - "asc" or "desc"
   * @param sortField - sort field, e.g. 'id' ...
   * @searchTerm - used to perform a "... username like '%searchTerm%'"
   * @returns {Promise}
   */
  getUsersAccountsInfo(pageNumber, pageSize, sortDir, sortField, searchTerm, searchField) {
    let path = `${privateAccountPath}?page=${pageNumber}&size=${pageSize}&` +
                        `sortDir=${sortDir}&sortField=${sortField}&searchTerm=${searchTerm}&searchField=${searchField}`
    return Api.get(path)
  },

  /**
   * Retrieve the account details for a user
   * @param username
   * @returns {Promise}
   */
  getUsersAccountInfo(username) {
    let path = `${privateAccountPath}/${username}`
    return Api.get(path)
  },

  /**
   * gets the list of devices used by this user over the last 1000 Event entries
   * @param username
   * @returns {Promise}
   */
  getUsersAgents(username) {
    let path = `${privateAccountPath}/useragents/${username}`
    return Api.get(path)
  },

  /**
   *
   * @param {String} emailAddress
   */
  // reset password when not signed in
  resetPasswordRequestPublic(emailAddress) {
    const data = {
      email: emailAddress
    }

    return Api.post(publicResetPasswordRequestPath, data)
  },

  // reset password when signed signed in
  resetPasswordRequestPrivate(username, emailAddress) {
    const data = {
      email: emailAddress
    }

    return Api.post(`${privateAccountPath}/${username}/resetpasswordrequest`, data)
  },

  resetPasswordPublic(resetToken, newPassword) {
    const data = {
      token: resetToken,
      password: newPassword
    }
    return Api.post(resetPasswordPathPublic, data)
  },

  resetPasswordPrivate(username, newPassword, oldPassword) {
    const data = {
      newPassword: newPassword,
      oldPassword: oldPassword
    }
    const encodedUsername = encodeURIComponent(username)
    const resetPasswordPathPrivate = `${privateAccountPath}/${encodedUsername}/resetpassword`
    return Api.post(resetPasswordPathPrivate, data)
  },

  getAccountInfo(username) {
    const encodedUsername = encodeURIComponent(username) // in case there are any awkward characters in the username
    const path = `${privateAccountPath}/${encodedUsername}`
    return Api.get(path)
  },

  getPolicyDocsToAccept(clinicianUsername) {
    const encodedClinicianUsername = encodeURIComponent(clinicianUsername)
    const path = `${privateAccountPath}/${encodedClinicianUsername}/${policyDocsPathPart}`
    return Api.get(path)
  },

  acceptPolicyDocs(clinicianUsername, docs) {
    const encodedClinicianUsername = encodeURIComponent(clinicianUsername)
    const path = `${privateAccountPath}/${encodedClinicianUsername}/${policyDocsPathPart}`
    return Api.put(path, docs)
  },

}
